export default function MysolvrEntry($resource, ENV) {
  'ngInject';

  return $resource(
    `${ENV.apiUrl}/pingsta/mysolvr_entries/:mysolvrEntryId.json`,
    { mysolvrEntryId: '@id' },
    {
      'query': {
        method: 'GET',
        isArray: false,
      },

      'approve': {
        method: 'POST',
        url: `${ENV.apiUrl}/pingsta/mysolvr_entries/:mysolvrEntryId/approve.json`,
        params: {
          mysolvrEntryId: '@id'
        },
      },

      'update': {
        method: 'PUT',
        url: `${ENV.apiUrl}/pingsta/mysolvr_entries/:mysolvrEntryId.json`,
        params: {
          mysolvrEntryId: '@id'
        },
      },
    }
  );
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/util/mysolvr-entry.factory.js